__turbopack_context__.v({
  "colorSet-base": "announcementbanner-module-scss-module__6FIvQq__colorSet-base",
  "colorSet-inverse": "announcementbanner-module-scss-module__6FIvQq__colorSet-inverse",
  "colorSet-sxmBlue": "announcementbanner-module-scss-module__6FIvQq__colorSet-sxmBlue",
  "contentWrapper": "announcementbanner-module-scss-module__6FIvQq__contentWrapper",
  "cta": "announcementbanner-module-scss-module__6FIvQq__cta",
  "ctasWrapper": "announcementbanner-module-scss-module__6FIvQq__ctasWrapper",
  "dismissButton": "announcementbanner-module-scss-module__6FIvQq__dismissButton",
  "dismissIcon": "announcementbanner-module-scss-module__6FIvQq__dismissIcon",
  "geoContentWrapper": "announcementbanner-module-scss-module__6FIvQq__geoContentWrapper",
  "geoCta": "announcementbanner-module-scss-module__6FIvQq__geoCta",
  "geoCtasWrapper": "announcementbanner-module-scss-module__6FIvQq__geoCtasWrapper",
  "geoDismissButton": "announcementbanner-module-scss-module__6FIvQq__geoDismissButton",
  "geoLayout": "announcementbanner-module-scss-module__6FIvQq__geoLayout",
  "geoLeadingIconWrapper": "announcementbanner-module-scss-module__6FIvQq__geoLeadingIconWrapper",
  "iconWrapper": "announcementbanner-module-scss-module__6FIvQq__iconWrapper",
  "leadingIconWrapper": "announcementbanner-module-scss-module__6FIvQq__leadingIconWrapper",
  "noDismissbutton": "announcementbanner-module-scss-module__6FIvQq__noDismissbutton",
  "text": "announcementbanner-module-scss-module__6FIvQq__text",
  "textWrapper": "announcementbanner-module-scss-module__6FIvQq__textWrapper",
});
